<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <div>
            <b-form @submit.prevent="fetch(1)">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Recherche par Groupe">
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="SearchIcon" size="16" class="text-muted" />
                      </b-input-group-prepend>
                      <b-form-input v-model="filter.q" placeholder="Recherche par Groupe" class="border-left-0" />
                      <div
                        v-if="hasAnyFilter"
                        class="input-group-text reset-pill" title="Réinitialiser les filtres"
                        role="button"
                        tabindex="0"
                        @mousedown.prevent
                        @click="resetFilters"
                        @keyup.enter="resetFilters"
                      >
                        <feather-icon icon="XIcon" size="14" class="text-danger mr-25" />
                        <span class="text-danger font-small-3">Réinitialiser</span>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="12" class="mt-1">
                  <b-button type="submit" variant="primary">Recherche</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-card no-body>
      <div class="m-2">
        <b-button
            variant="primary"
            :to="{ name: 'creer-groupe'}"
        >
          Créer groupe
        </b-button>
      </div>
      <b-table v-if="items"
               ref="selectableTable"
               :fields="fields"
               :items="items"
               responsive
               class="mb-0"
      >
        <template #cell(actions)="data">
          <b-button :to="{ name: 'editer-groupe', params: {id: data.item.id}}"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'" size="sm" variant="outline-primary">
            Editer
          </b-button>
        </template>
      </b-table>
    </b-card>
    <div class="mx-2 mb-2" v-if="pagination.total">
      <b-row>
        <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="pagination.per_page"
              first-number
              last-number
              @change="fetch"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18"/>
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18"/>
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTable, BButton, BFormGroup, BCard, BFormInput,
  BInputGroup, BInputGroupPrepend
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import filterPersistence from '@/mixins/filterPersistence'

export default {
  mixins: [filterPersistence],
  components: {
    BCard,
    BTable,
    BButton,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      filterKey: 'groupes-list',
      fields: [
        'id',
        {key: 'libelle', label: 'Groupe'},
        {key: 'created_at', label: 'Créé le'},
        {key: 'updated_at', label: 'Modifié le'},
        {key: 'actions'}
      ],
      items: [],
      filter: {
        q: '',
      },
      is_loading: false,
      pagination: {},
    }
  },
  created() {
    this.fetch(this.restoredPage || 1);
  },
  computed: {
    hasAnyFilter() {
      const f = this.filter || {};
      return Object.keys(f).some(k => {
        const v = f[k];
        return v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);
      });
    }
  },
  methods: {
    resetFilters() {
      this.resetFilter();
      this.fetch(1);
    },
    fetch(page) {
      let _this = this;
      _this.is_loading = true;
      this.$store.dispatch('groupeModule/fetchAll', {
        page: page,
        ..._this.filter
      }).then(function (response) {
        _this.items = response.data;
        _this.pagination = response.meta;
        _this.is_loading = false;
      })
    },
  },
}
</script>

<style lang="scss">
.reset-pill {
  background: #fdecec;
  border-color: #ebe9f1;
  border-left: 0;
  cursor: pointer;
  transition: background .15s ease;
  display: flex;
  align-items: center;
  user-select: none;
}
.reset-pill:hover {
  background: #fbd9d9;
}
</style>
